// extracted by mini-css-extract-plugin
export default {"tableContainer":"questionPreviewTable_tableContainer__20e+z","title":"questionPreviewTable_title__ftPxW"};